import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Employer from "./Employer";

@Model()
class JobHiringProcessTimeline extends ApplicationRecord {
  static jsonapiType = "job_hiring_process_timelines";

  @Attr() jobPostedDate: string;

  @Attr() firstApplicationSubmissionDate: string;

  @Attr() firstInterviewDate: string;

  @Attr() firstOfferDate: string;

  @Attr() firstOfferAcceptedDate: string;

  @Attr() daysToFirstApplication: number;

  @Attr() daysFromApplicationToFirstInterview: number;

  @Attr() daysFromInterviewToFirstOffer: number;

  @Attr() daysFromOfferToFirstOfferAccepted: number;

  @BelongsTo(Employer) employer: Employer;
}

export default JobHiringProcessTimeline;
